<template>
    <div class="py-4">
        <p class="text-gray-900">
            <strong class="font-bold">{{
                $t('investment_process.vermanlg.vermanlg_consequences_of_revocation')
            }}</strong>
        </p>
        <p class="text-gray-500">
            {{ $t('investment_process.vermanlg.vermanlg_consequences_of_revocation_disclaimer') }}
        </p>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
